export enum NotificationCategory {
  OPERATION = 'OPERATION',
  RESERVATIONS = 'RESERVATIONS',
  TICKETS = 'TICKETS',
  PAYMENTS = 'PAYMENTS',
  ACCOUNT = 'ACCOUNT',
  COMMUNICATIONS = 'COMMUNICATIONS',
}
